import { PageWrapper, Popup } from '@approvalmax/ui/src/components';
import { hooks as pageHooks } from 'modules/page';
import { memo } from 'react';
import { useToggle } from 'react-use';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import Loading from '../../../loading';
import { useBudgetPolling } from '../../hooks/useBudgetPolling';
import { useBudgets } from '../../hooks/useBudgets';
import AddNewBudgetPopupContent from '../AddNewBudgetPopupContent/AddNewBudgetPopupContent';
import { BudgetListWrapper } from '../BudgetListWrapper/BudgetListWrapper';
import { Toolbar } from '../Toolbar/Toolbar';
import { BudgetList } from './components/BudgetList/BudgetList';

export const XeroBudgets = memo(() => {
    useBudgetPolling();

    const company = useCompanyBasedOnUrl();
    const { data, isInitialLoading, error, isError } = useBudgets();

    const isDisconnected = !company.flags.hasActiveIntegration;

    pageHooks.usePageError(error);

    const [isOpenUploadPopup, toggleIsOpenUploadPopup] = useToggle(false);

    const loadedEmpty = data && data.length === 0;

    if (isInitialLoading) {
        return <Loading />;
    }

    return (
        <>
            <Toolbar
                canUploadBudget
                showSettings
                isBudgetSyncEnabled={company.integration?.isBudgetSyncEnabled}
                isDisabled={isError || loadedEmpty}
                onUploadNewBudget={toggleIsOpenUploadPopup}
            />

            <PageWrapper.Content>
                <BudgetListWrapper
                    canCreateBudget
                    isDisconnected={isDisconnected}
                    isError={isError}
                    hasBudgets={!loadedEmpty}
                    onUploadNewBudget={toggleIsOpenUploadPopup}
                >
                    <BudgetList />
                </BudgetListWrapper>
            </PageWrapper.Content>

            <Popup open={isOpenUploadPopup} onToggle={toggleIsOpenUploadPopup}>
                <AddNewBudgetPopupContent toggleIsOpenPopup={toggleIsOpenUploadPopup} />
            </Popup>
        </>
    );
});

XeroBudgets.displayName = 'XeroBudgets';
